import { createSimpleStore } from '../../hooks/useSimpleStore';

import type { ShortcutActionConfig } from './ShortcutManager.types';

export type ActionDefinitions = { [key: string]: ShortcutActionConfig & { keyBinding: string } };

export const actionStore = createSimpleStore({} as ActionDefinitions);
